import { render } from "./AdmSearchClients.vue?vue&type=template&id=916f1c04&scoped=true&ts=true"
import script from "./AdmSearchClients.vue?vue&type=script&lang=ts"
export * from "./AdmSearchClients.vue?vue&type=script&lang=ts"

import "./AdmSearchClients.vue?vue&type=style&index=0&id=916f1c04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916f1c04"]])

export default __exports__